<template>
   <main class="post">
    <div class="blog" v-if='loaded'>
    
     <transition-group class="blog-grid" name="list">
      <BlogItem class="blog-item" v-for="post in postsByCategory" :key="post.id" :post="post" />
     </transition-group>

    </div>

    <Pagination v-if="loaded"/>
    
    <div class="loading" v-if="!loaded">
      <loading-spinner></loading-spinner>
    </div>
    
    <Footer v-if='loaded' />
  </main>
</template>

<script>
import BlogItem from '../../components/Blog/BlogItem.vue';
import Footer from '../../components/Footer/Footer.vue';

export default {

  components: { 
    BlogItem,
    Footer,
  },

  computed: {
      postsByCategory() {
        return this.$store.state.postsByCategory;
      },
      currentCategory() {
        return this.$store.state.currentCategory;
      },
      currentPage() {
        return this.$store.state.currentPage;
      }
  },

  mounted() {
    this.getPostsByCategory();
  },
  
  data() {
    return {
      loaded: false, 
      timer: null,
      headerImg: null
    }
  },

  methods: {
    getPostsByCategory() {

      const slug = this.$route.params.slug;
      const posts_per_page = this.$wpoptions.posts_per_page;

      //TODO - get category param somehow.
      this.$store.dispatch('getPostsByCategory', { per_page: posts_per_page, page: this.$store.state.currentPage }).then(res => {

        this.$store.state.totalPages = Array.from( { length: res.headers['x-wp-totalpages'] }, (value, key) => ++key); 
        let filteredData = res.data.filter(post => post.cat_name[0].slug !== slug ? false : true);

        this.$store.commit('setPostsByCategory', res.data);

        // Sets a random header image based on posts of single category
        let array = filteredData;
        let random = Math.floor(Math.random() * array.length);

        for (let i = 0; i < array.length; i++) {
          this.headerImg = array[random];
        }

        this.getCategory();

      })
    },
    getCategory() {
          const slug = this.$route.params.slug;
          // Set hero for current category
          this.$store.dispatch('getCategory', slug).then(data => {
          if (!data) {
            return this.$router.push('/404');
          }

          this.$store.commit('setCurrentCategory', data.name); 

          // Add gradient background if there is no img
          if(!data.category_img) {
              let scrollPost = document.querySelector('.scroll-post');
              scrollPost.classList.add('gradient-bg');
          } else {
              data.category_img = this.headerImg.featured_image_src.full[0];
          }

          const slide = {
            ...data,
            video: data.acf.video,
            img: data.category_img,
            title: 'Category: ' + this.$store.state.currentCategory,
            url: data.link,
            color: data.acf.color_theme || 'white',
            themeColor: data.acf.theme_color || 'white',
            buttonClass: data.acf.button_style,
          };

          this.$store.commit('setHeroAndNavigate', {
            slide,
          });

          this.timer = setTimeout(() => this.loaded = true, 600);

        }), rejected => {
          return this.$router.push('/404');
        }
    }
},

watch: {
  '$route'(to, from) {
    this.getPostsByCategory();
  },
  currentPage: function() {
    this.getPostsByCategory();
  }
}

}
</script>

<style lang="scss" scoped>

</style>